import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Footer from "../common/Footer";
import Navbar from "../common/Navbar";
import ClickToWhatsappAds from "../components/service/ClickToWhatsappAds";
import { Helmet } from "react-helmet";

const WhatsappClick = () => {
  const location = useLocation();
  useEffect(() => {
    const { search } = location;
    if (!search) {
      window.scroll(0, 0);
    }
  }, [location.pathname]);

  console.log("locationioio", location)

  return (
    <>
      <Helmet>
        <title>WhatsApp Services for High-Converting Click Ads</title>
        <meta
          name="description"
          content="Generate more leads with powerful WhatsApp services using Click to WhatsApp ads. Start real-time conversations and boost conversions today!"
        />
      </Helmet>

      <div>
        <Navbar />
        <ClickToWhatsappAds />
        <Footer />
      </div>
    </>
  );
};

export default WhatsappClick;
